import { render } from "./ViolationDetailView.vue?vue&type=template&id=127d0bdb"
import script from "./ViolationDetailView.vue?vue&type=script&lang=js"
export * from "./ViolationDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__